import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import color from '../../../theme/color';

import {
  Root,
  ButtonWrapper,
  Wrapper,
  Container,
  IconWrapper,
  ActiveButton,
  Button,
  PositionIcon
} from './styles';

class Floor extends PureComponent {
  handleFloor = value => {
    this.props.onChangeFloor(value);
  };

  renderLevelIcon = floor => {
    const { itineraryStart, itineraryFinish, t } = this.props;
    const itineraryKeyName = t('common:plan.filter.placeholder');

    if (
      itineraryStart.label !== itineraryKeyName ||
      itineraryFinish.label !== itineraryKeyName
    ) {
      let startIcon = null;
      let finishIcon = null;

      if (
        itineraryStart.label !== itineraryKeyName &&
        itineraryStart.floor.toString() === floor
      ) {
        startIcon = (
          <IconWrapper>
            <PositionIcon name="user" color={color.primary} />
          </IconWrapper>
        );
      }

      if (
        itineraryFinish.label !== itineraryKeyName &&
        itineraryFinish.floor.toString() === floor
      ) {
        finishIcon = (
          <IconWrapper>
            <PositionIcon name="event" color={color.primary} />
          </IconWrapper>
        );
      }

      return startIcon || finishIcon ? (
        <Container>
          {startIcon}
          {finishIcon}
        </Container>
      ) : null;
    }
  };

  render() {
    const { readOnly, currentFloor, t } = this.props;

    const groundLevel =
      currentFloor === 0 ? (
        <ActiveButton onClick={() => this.handleFloor(0)}>
          {t('common:plan.floors.ground')}
        </ActiveButton>
      ) : (
        <Button onClick={() => this.handleFloor(0)}>
          {t('common:plan.floors.ground')}
        </Button>
      );
    const subLevel =
      currentFloor === -1 ? (
        <ActiveButton onClick={() => this.handleFloor(-1)}>
          {t('common:plan.floors.level')} -1
        </ActiveButton>
      ) : (
        <Button onClick={() => this.handleFloor(-1)}>
          {t('common:plan.floors.level')} -1
        </Button>
      );

    return (
      <Root readOnly={readOnly}>
        <ButtonWrapper>
          <Wrapper>
            {subLevel}
            {this.renderLevelIcon('-1')}
          </Wrapper>
          <Wrapper>
            {groundLevel}
            {this.renderLevelIcon('0')}
          </Wrapper>
        </ButtonWrapper>
      </Root>
    );
  }
}

Floor.propTypes = {
  readOnly: PropTypes.bool,
  itineraryStart: PropTypes.object,
  itineraryFinish: PropTypes.object,
  onChangeFloor: PropTypes.func.isRequired,
  currentFloor: PropTypes.number.isRequired
};

export default translate()(Floor);
